"use client";

import { useCallback, useEffect, useState } from "react";

// Llamadas JSON a la API; lanzan Error con el mensaje del servidor.
export async function api<T = unknown>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as { error?: string }).error || "Error inesperado");
  return data as T;
}

const json = (method: string, body: unknown): RequestInit => ({
  method,
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(body),
});
export const post = <T = unknown>(url: string, body: unknown) => api<T>(url, json("POST", body));
export const put = <T = unknown>(url: string, body: unknown) => api<T>(url, json("PUT", body));
export const del = <T = unknown>(url: string) => api<T>(url, { method: "DELETE" });

// Lectura con recarga manual y sondeo opcional. Solo devuelve datos de la url actual.
export function useApi<T>(url: string | null, interval?: number) {
  const [state, setState] = useState<{ url: string; data: T } | null>(null);
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    if (!url) return;
    let live = true;
    const load = () =>
      api<T>(url)
        .then((data) => live && setState({ url, data }))
        .catch(() => {});
    load();
    if (!interval) return () => { live = false; };
    const timer = setInterval(load, interval);
    return () => {
      live = false;
      clearInterval(timer);
    };
  }, [url, interval, tick]);

  return { data: state && state.url === url ? state.data : undefined, reload };
}
